import { z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';
import { CityKeySchema } from '../city-key/city-key';
import { VENUE_SEARCH_MAX_LENGTH } from '../venues-list-query/venues-list-query';

/**
 * The member venue browse (P25e) — `03-meetings.md`'s "venue browse (city
 * filter)".
 *
 * ## Two parameters the admin list has, and this one must not
 *
 * **`isActive` is absent, and that is the whole publication rule.** The admin
 * query whitelists it because an operator legitimately reads both halves of the
 * directory; a member reads one. Publication is resolved by the service, which
 * supplies `isActive: true` into the shared `VENUE_FILTER_SPEC` itself — so
 * there is no parameter to omit, in N7's own words: *"a filter a client can send
 * is a filter a client can omit."* It sits beside soft-delete and status
 * visibility as a scope, not a filter.
 *
 * **`ids` is absent** because it exists for the admin kit's `ServerSelect` (W6),
 * which has to render a saved value that is not on the page the picker is
 * showing. A browse has no saved value and nothing to resolve by id — the member
 * reads one venue at `GET /venues/:id`.
 *
 * `search` reaches the venue's translated name and city, resolved across every
 * locale by the same `VENUE_FILTER_SPEC` the admin list uses, which is why the
 * read must go through `paginateFilteredLocalized` and never `paginateFiltered`
 * (P25a1: the translatable half is silently skipped otherwise).
 */
export const MemberVenuesListQuerySchema = makeListQuery({
  cityKey: CityKeySchema.optional(),
  search: z.string().trim().min(1).max(VENUE_SEARCH_MAX_LENGTH).optional(),
});

export type MemberVenuesListQuery = z.infer<typeof MemberVenuesListQuerySchema>;
